import React, { useEffect, useState } from "react";
import "./Confirmation.css";
import { SummaryCard, SummaryRow } from "../SummaryCard";
import { BASE_URL } from "../../helpers/api";
import {
  FiClipboard, FiUser, FiCreditCard, FiMail, FiPhone, FiMapPin, FiHome,
  FiUserCheck, FiCalendar, FiClock, FiBookmark, FiDollarSign,
} from "react-icons/fi";

export default function ConfirmationPage({ amount, paymentId, paymentMethod }) {
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAppointment = async () => {
      const appointmentId = localStorage.getItem("appointment_id");
      if (!appointmentId) {
        setLoading(false);
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/appointments/${appointmentId}`);
        const data = await res.json();
        setAppointment(data);
      } catch (err) {
        console.error("Error fetching appointment:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointment();
  }, []);

  if (loading) {
    return <p>Loading confirmation...</p>;
  }

  if (!appointment) {
    return <p>No appointment details found.</p>;
  }

  return (
    <div className="confirmation-container">
      <h2>Thank You For Booking Appointment Slot</h2>
      {paymentMethod === "hospital" ? (
        <p className="secure-note">🏥 Please Pay at the Hospital</p>
      ) : (
        <div className="paid-stamp-wrap">
          <div className="paid-stamp">Paid</div>
        </div>
      )}

      <div className="booking-details">
        <h3 className="booking-details-title">Appointment Slot Booking Details</h3>

        {/* Booking/identity info first, then clinical/visit info — same
            grouping and field order as the pre-payment Appointment Summary
            screen, so both places show the exact same story. */}
        <SummaryCard icon={<FiClipboard />} title="Appointment Details">
          <SummaryRow icon={<FiUser />} label="Patient Name" value={appointment?.patient?.name} />
          <SummaryRow icon={<FiCreditCard />} label="Patient ID" value={appointment?.patient?.patient_id} />
          <SummaryRow icon={<FiMail />} label="Email" value={appointment?.patient?.email} />
          <SummaryRow icon={<FiPhone />} label="Phone" value={appointment?.patient?.phone} />
          <SummaryRow icon={<FiMapPin />} label="Location" value={appointment?.location?.name} />
          <SummaryRow icon={<FiHome />} label="Department" value={appointment?.doctor?.specialty} />
          <SummaryRow icon={<FiUserCheck />} label="Doctor Name" value={appointment?.doctor?.name} />
          <SummaryRow icon={<FiCalendar />} label="Appointment Date" value={appointment?.date} />
          <SummaryRow
            icon={<FiClock />}
            label="Appointment Time"
            value={appointment?.time_slot && appointment?.timezone
              ? `${appointment.time_slot} ${appointment.timezone}`
              : appointment?.time_slot}
          />
          {/* Same single visit-type selection as the pre-payment summary —
              shown once as Appointment Type, not duplicated as "reason". */}
          <SummaryRow icon={<FiClipboard />} label="Appointment Type" value={appointment?.problem} />
          <SummaryRow icon={<FiBookmark />} label="Appointment ID" value={appointment?.appointment_id} />
        </SummaryCard>

        {/* Payment */}
        <SummaryCard icon={<FiDollarSign />} title="Payment Details">
          <SummaryRow
            icon={<FiDollarSign />}
            label="Payment Status"
            value={paymentMethod === "hospital" ? "Pay at Hospital (Pending)" : paymentId ? "Paid Online" : "Pending"}
          />
          {paymentId && <SummaryRow icon={<FiCreditCard />} label="Payment ID" value={paymentId} />}
          <SummaryRow
            icon={<FiDollarSign />}
            label={paymentMethod === "hospital" ? "Amount Due" : "Amount Paid"}
            value={`₹${amount}`}
          />
        </SummaryCard>
      </div>
    </div>
  );
}